export default __webpack_public_path__ + "static/media/survey-detail-bg.1fb51311.svg";